import CustomerTable from "./CustomerTable";
import CommonButtons from "../../../../../../shared/components/CommonButtons";
import { ModalWrapper } from "../../../../../../shared/components/ModalWrapper";
import { useUserTheme } from "src/shared/utils/useUserTheme";
import { CustomerData } from "src/shared/services/interfacev2";

interface Props {
  onSelectCustomer: (customer: CustomerData) => void;
  onAddCustomer: () => void;
  backHome: () => void;
  customers: CustomerData[];
  total: { totalRecords: string; totalPage: string };
  pageNumber: number;
  setPageNumber: (page: number) => void;
  loading?: boolean;
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

const CustomerSelection: React.FC<Props> = ({ onSelectCustomer, onAddCustomer, backHome, customers, total, pageNumber, setPageNumber, loading, searchTerm, onSearchChange, }) => {
  const { fontClass, borderHighlight } = useUserTheme();

  const handleSearchChange = (value: string) => {
    onSearchChange(value);
    setPageNumber(1);
  };



  return (
    <ModalWrapper title="Select Customer" onClose={backHome} width="max-w-2xl" className="min-w-[580px]" positionClass="top-0 left-0 right-0 mt-16 h-full">
      <div className="flex flex-col gap-1">
        <div className="flex items-center justify-between gap-3">
          <div className="flex-1 max-w-md">
            <input type="text" value={searchTerm} onChange={(e) => handleSearchChange(e.target.value)} placeholder="Search by Name or Phone number"
              className={`w-full px-3 py-2.5 border rounded-md focus:outline-none focus:ring-2 ${borderHighlight} ${fontClass} text-sm text-black`} />
            {/* <TextField label="Search by Name or Phone number" variant="outlined" value={searchTerm} onChange={(e) => handleSearchChange(e.target.value)} fullWidth /> */}
          </div>
          <div className="flex gap-2">
            <CommonButtons label="Add Product" variant="primary" onClick={backHome} className="w-36" />
            <CommonButtons label="Add Customer" onClick={onAddCustomer} className="w-36" />
          </div>
        </div>
        <div className="flex-1 overflow-y-auto w-full mt-2">
          <CustomerTable customers={customers} total={total} pageNumber={pageNumber} setPageNumber={setPageNumber} onSelect={(id, customer) => onSelectCustomer(customer)} searchTerm={searchTerm} onSearchChange={handleSearchChange} />
        </div>
        <div className="w-[530px] -ml-[0px] flex justify-center bg-[#8a8e8b] text-black p-2 rounded-[10px] font-bold text-lx">
          <i>Note: Go to the settings page if you need to modify any customer information.</i>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default CustomerSelection;
